import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { DELETE_MESSAGE } from "../../common/Constant";
import { toastSuccess } from "../../common/Toast";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material';

const DeleteConfirmation = ({ deleteApiUrl, open, data11,onClose,quickbookarray,openingbalance }) => {
  console.log(open,data11,"220520");
  const handleSubmit = () => {
    //put your validation logic here
    const token = localStorage.getItem("Token");
    const deleteRequestParam = localStorage.getItem("DeleteRequestParam");
    console.log(deleteRequestParam,"deleterdata")

   

    axios
      .post(`${deleteApiUrl}`, deleteRequestParam, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then(() => {
        toastSuccess(DELETE_MESSAGE);
        data11 == true ? onClose() : window.location.reload();
        
      })
      .catch((error) => {
        console.error("Error during deletion:", error);
  
        onClose();
      });

    onClose();
  };


  return (
    <Dialog open={open}>
      {Number(openingbalance)==0 ?
      <DialogTitle textAlign="center" >Confirmation</DialogTitle>: ""}
      <DialogContent>
        {Number(openingbalance)>0 ? "You Cannot Delete this Record Because Your Opening Balance is Greater than Zero" : "Are you sure you want to delete this record?" }
      </DialogContent>
      {Number(openingbalance)>0 ?  <DialogActions sx={{ p: '1.25rem' }}>
        <Button class="btn btn-sm btn-primary"  onClick={onClose}>OK</Button>
      </DialogActions>: 
      <DialogActions sx={{ p: '1.25rem' }}>
        <Button class="btn btn-sm btn-outline-dark"  onClick={onClose}>Cancel</Button>
        <Button class="btn btn-sm btn-primary" onClick={handleSubmit} variant="contained">
          Delete
        </Button>
      </DialogActions>}
    </Dialog>
  );



};

export default DeleteConfirmation;
